export default function isNumber(input) {
  if (+input === parseInt(input, 10)) {
    return true;
  }
  return false;
}
export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}



// WEBPACK FOOTER //
// ./src/utils/numbers/isNumber.js